import React, { Component } from "react";
import ReactTable from "react-table";
import PropTypes from "prop-types";
import { Button, Tooltip, OverlayTrigger } from "react-bootstrap";
import "react-table/react-table.css";
import * as moment from "moment";
import "moment/locale/pt-br";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faListUl,
  faUserTag,
  faTimes,
  faCog,
} from "@fortawesome/free-solid-svg-icons";

const STATUS_PEDIDO = {
  CRIADO: "criado",
  RECEBIDO: "recebido",
  EM_SEPARACAO: "em_separacao",
  SEPARADO: "separado",
  LIBERADO: "liberado",
  EM_TRANSITO: "em_transito",
  CHEGOU: "chegou",
  ENTREGUE: "entregue",
  CANCELADO: "cancelado",
  ENTREGA_FINALIZADA: "entrega_finalizada",
};

export default class TBLPedidos extends Component {
  constructor(props) {
    super(props);
    this.columns = [
      {
        Header: "Código",
        accessor: "codigo",
        width: 120,
        className: "center",
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: (props) => <span>{props.value.toUpperCase()}</span>,
        className: "center",
        width: 150,
      },
      {
        Header: "Data",
        Cell: (row) =>
          row.row._original.agendado ? (
            <span>
              {moment(row.row._original.dataAgendamento).format("l")}{" "}
              {moment(row.row._original.dataAgendamento).format("LT")}
            </span>
          ) : (
            <span>
              {moment(row.row._original.createdAt).format("l")}{" "}
              {moment(row.row._original.createdAt).format("LT")}
            </span>
          ),
        className: "center",
      },
      {
        Header: "Cliente",
        accessor: "cliente",
        Cell: (props) => <span>{props.value ? props.value.nome : null}</span>,
        className: "center",
      },
      {
        Header: "Recorrência",
        accessor: "cliente",
        Cell: (props) => (
          <span
            style={{
              textTransform: "uppercase",
              color: "white",
              ...this.mudarBackgroundRecorrencia(
                props.value ? props.value.tipo_recorrencia : null
              ),
            }}
          >
            {props.value ? props.value.tipo_recorrencia : null}{" "}
          </span>
        ),
        className: "center",
      },
      {
        Header: "Endereço",
        accessor: "endereco_cliente",
        Cell: (props) => (
          <span>
            <span>
              {props.value ? props.value.rua : null}{" "}
              {props.value ? props.value.numero : null}{" "}
              {props.value ? props.value.bairro : null}
            </span>
          </span>
        ),
        width: 280,
      },
      {
        Header: "Valor Total",
        accessor: "valor_total",
        Cell: (props) => <span>R$ {parseFloat(props.value).toFixed(2)}</span>,
        className: "right",
      },
      {
        Header: "Separador",
        accessor: "separador",
        Cell: (props) => <span>{props.value ? props.value.nome : null}</span>,
        className: "center",
      },
      {
        Header: "Entregador",
        accessor: "entregador",
        Cell: (props) => <span>{props.value ? props.value.nome : null}</span>,
        className: "center",
      },
      {
        Header: "Ações",
        Cell: (row) => (
          <>
            <OverlayTrigger
              placement={"left"}
              overlay={<Tooltip>Ver itens</Tooltip>}
            >
              <Button
                style={{ marginRight: 4 }}
                onClick={() => {
                  this.gerenciarAcoes("ver_itens", row.row._original);
                }}
              >
                <FontAwesomeIcon icon={faListUl}></FontAwesomeIcon>
              </Button>
            </OverlayTrigger>
            <OverlayTrigger
              placement={"left"}
              overlay={<Tooltip>Despachar Separador</Tooltip>}
            >
              <Button
                disabled={
                  !(
                    row.row._original.status === "recebido" ||
                    row.row._original.status === "agendado"
                  ) || row.row._original.separador
                }
                style={{ marginRight: 4 }}
                onClick={() => {
                  this.gerenciarAcoes("despachar_separador", row.row._original);
                }}
              >
                <FontAwesomeIcon icon={faUserTag}></FontAwesomeIcon>
              </Button>
            </OverlayTrigger>

            <OverlayTrigger
              placement={"left"}
              overlay={<Tooltip>Alterar Pedido</Tooltip>}
            >
              <Button
                style={{ marginRight: 4 }}
                variant="primary"
                onClick={() =>
                  this.gerenciarAcoes("alterar-pedido", row.row._original)
                }
              >
                <FontAwesomeIcon icon={faCog}></FontAwesomeIcon>
              </Button>
            </OverlayTrigger>
          </>
        ),
        className: "center",
        width: 170,
      },
    ];
  }

  mudarBackgroundRow = (status) => {
    if (status === STATUS_PEDIDO.RECEBIDO) {
      return "#d8eff0";
    } else if (status === STATUS_PEDIDO.EM_SEPARACAO) {
      return "#f0f69f";
    } else if (status === STATUS_PEDIDO.SEPARADO) {
      return "#ff8a5c";
    } else if (status === STATUS_PEDIDO.LIBERADO) {
      return "#ab93c9";
    } else if (status === STATUS_PEDIDO.EM_TRANSITO) {
      return "#82acff";
    } else if (status === STATUS_PEDIDO.CHEGOU) {
      return "#b0e0a8";
    } else if (status === STATUS_PEDIDO.ENTREGUE) {
      return "#00b7a8";
    } else if (status === STATUS_PEDIDO.CANCELADO) {
      return "#d62321";
    } else if (status === STATUS_PEDIDO.ENTREGA_FINALIZADA) {
      return "#8be67c";
    } else {
      return "#f5f5f5";
    }
  };

  mudarBackgroundRecorrencia = (status) => {
    if (status === "novo") {
      return { backgroundColor: "red" };
    } else if (status === "reativado") {
      return { backgroundColor: "blue" };
    } else {
      return { backgroundColor: "green" };
    }
  };

  gerenciarAcoes = (tipo, dados) => {
    if (tipo === "ver_itens") {
      this.props.dataCallback(tipo, dados);
    } else if (tipo === "despachar_separador") {
      this.props.dataCallback(tipo, dados);
    } else if (tipo === "cancelar_pedido") {
      this.props.dataCallback(tipo, dados);
    } else if (tipo === "alterar-pedido") {
      this.props.dataCallback(tipo, dados);
    } else {
      return;
    }
  };

  render() {
    const { data, pages, loading, showPagination, limit, changePage } =
      this.props;
    return (
      <ReactTable
        data={data}
        className="-striped -highlight"
        columns={this.columns}
        resizable
        style={{ height: 572, maxHeight: 572 }}
        getTrProps={(state, rowInfo) => {
          //adiciona eventos a cada célula
          if (rowInfo && rowInfo.row) {
            let row = rowInfo.row._original;
            return {
              style: {
                color: "black",
                background: this.mudarBackgroundRow(row.status),
              },
            };
          } else {
            return {
              style: {
                color: "black",
              },
            };
          }
        }}
        manual
        pages={pages}
        onPageChange={(page) => changePage(page + 1)}
        showPagination={showPagination}
        defaultPageSize={limit}
        loading={loading}
        previousText="Anterior"
        nextText="Próximo"
        loadingText="Carregando pedidos..."
        noDataText="Nenhum pedido encontrado!"
        pageText="Página"
        ofText="de"
        rowsText="linhas"
      />
    );
  }
}

TBLPedidos.propTypes = {
  data: PropTypes.array,
  dataCallback: PropTypes.func,
  showPagination: PropTypes.bool,
  handleShowAlert: PropTypes.func,
  getPedidos: PropTypes.func,
  limit: PropTypes.number,
  pages: PropTypes.number,
  loading: PropTypes.bool,
  changePage: PropTypes.func,
};
